import { render, staticRenderFns } from "./ConfigGroupIcon.vue?vue&type=template&id=9c39bf90"
import script from "./ConfigGroupIcon.vue?vue&type=script&lang=js"
export * from "./ConfigGroupIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports